import React, { Component } from "react";
import FormContainer from "./container/FormContainer";
import GRUContainer from "./container/GRUContainer";
import { ButtonFields, Card } from "react-template";
import "../../assets/css/components/formbuilder/preview.css";
class Preview extends Component {
  constructor(props) {
    super(props);
    this.voltar = this.voltar.bind(this);
  }

  voltar() {
    this.props.fechaPreview();
  }

  tools() {
    return (
      <div>
        <ButtonFields
          content="Voltar"
          type="button"
          button="colored"
          icon="arrow_back"
          color="transparent"
          onClick={this.voltar}
        />
      </div>
    );
  }

  render() {
    return (
      <Card
        className="fb-preview"
        titulo="Pre-Visualização"
        noPadding
        tools={this.tools()}
      >
        {this.props.tipoForm === "form" ? (
          <FormContainer
            schema={this.props.formSchema.schema}
            uiSchema={this.props.formSchema.uiSchema}
          />
        ) : this.props.tipoForm === "gru" ? (
          <GRUContainer
            schema={this.props.formSchema.schema}
            uiSchema={this.props.formSchema.uiSchema}
          />
        ) : null}
      </Card>
    );
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/components/formbuilder/Preview.js